import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useT, useTRaw } from "@/context/ContentContext";

export default function HomeManifesto() {
    const t = useT();
    const tRaw = useTRaw();
    return (
        <section className="py-16 sm:py-24 bg-white">
            <div className="max-w-4xl mx-auto px-6 sm:px-10">
                <div className="eyebrow mb-6"><span className="logo-mark text-sm text-white">H<span className="dot !text-[hsl(var(--copper))]">.</span></span> {t("home.manifesto.eyebrow", "Manifesto curto")}</div>
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
                    {(() => {
                        const raw = tRaw("home.manifesto.title", "Habituámo-nos a ter medo das obras.");
                        const parts = raw.split(/(\bmedo\b)/i);
                        return parts.map((p, i) => /^medo$/i.test(p)
                            ? <span key={i} className="font-serif-italic text-[hsl(var(--copper))]">{p}</span>
                            : <span key={i}>{p}</span>);
                    })()}
                </h2>
                <div className="mt-8 space-y-5 text-lg text-[hsl(var(--graphite))]/85 leading-relaxed">
                    <p>{t("home.manifesto.p1", "Aos orçamentos que começam num valor e acabam noutro. Aos prazos que existem no papel, mas raramente no calendário. Aos telefonemas que deixam de ser atendidos.")}</p>
                    <p>{t("home.manifesto.p2", "Nós não acreditamos que tenha de ser assim. Foi dessa convicção que nasceu O Homem da Obra — para ajudar a mudar a forma como as obras são feitas e, sobretudo, como as pessoas são tratadas durante uma obra.")}</p>
                    <p className="text-[hsl(var(--forest))] font-medium">{t("home.manifesto.p3", "Não prometemos obras onde nada corre mal. Prometemos estar presentes quando alguma coisa correr mal — com verdade, comunicação e vontade de resolver.")}</p>
                </div>
                <Link to="/sobre-nos" className="btn-outline-dark mt-10">
                    Ler o manifesto completo
                    <span className="arrow-circle"><ArrowUpRight className="w-3.5 h-3.5" /></span>
                </Link>
            </div>
        </section>
    );
}
